// @flow
import Enum from 'common/enums/Enum';

export const ZoneMapGeometryStatusEnum = new Enum({
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Hidden: 'HIDDEN',
    New: 'NEW',
    Search: 'SEARCH'
});
